import { render } from "./Experiments.vue?vue&type=template&id=1c6150e5"
import script from "./Experiments.vue?vue&type=script&lang=js"
export * from "./Experiments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__